var _defs, _rect, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidedrawerCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.98 18.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cals-1,.cals-2{fill:#a71f23;}.cals-2{opacity:.15;}.cals-3{fill:none;stroke:#a71f23;stroke-miterlimit:10;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cals-2",
    x: 0.85,
    y: 0.9,
    width: 16.33,
    height: 4.77
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cals-1",
    d: "m4.11,6.12h9.77c.8,0,.81-1.25,0-1.25H4.11c-.8,0-.81,1.25,0,1.25h0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cals-1",
    cx: 13.49,
    cy: 9.54,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cals-1",
    cx: 4.49,
    cy: 9.54,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cals-1",
    cx: 9.02,
    cy: 9.54,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cals-1",
    cx: 4.54,
    cy: 13.85,
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cals-1",
    cx: 9.07,
    cy: 13.85,
    r: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cals-1",
    cx: 13.54,
    cy: 13.85,
    r: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cals-3",
    x: 0.5,
    y: 0.5,
    width: 16.98,
    height: 17.06,
    rx: 2.01,
    ry: 2.01
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidedrawerCalendarIcon);
export default __webpack_public_path__ + "static/media/sidedrawer-calendar-icon.e9c4c755b5ef16a239ae691bada166d5.svg";
export { ForwardRef as ReactComponent };